module.exports = __webpack_public_path__ + "media/images/pc/special_reports/separator_skyblue-1f2a927b456ed9789da5f12540af4cfb.jpg";